import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * 디자인 토큰(shared/styles/tokens.css)의 커스텀 타이포 크기를 tailwind-merge에 알려 준다.
 * 모르면 text-body-14 를 색상으로 보고 text-fg-* 와 충돌한다며 지워 버린다.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'heading-28',
            'heading-24',
            'heading-20',
            'subtitle-18',
            'subtitle-16',
            'body-16',
            'body-15',
            'body-14',
            'body-13',
            'label-14',
            'button-18',
            'button-16',
            'button-14',
            'button-12',
          ],
        },
      ],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
